import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const dynamicBaseQuery = async (args, api, extraOptions) => {
  const environment = process.env.REACT_APP_ENV;

  const baseUrl =
    environment === "production" || environment === "prod"
      ? "https://demo.order2ucloud.com/veevareconcileservice"
      : `https://demo.${environment}.order2ucloud.com/veevareconcileservice`;

  const rawBaseQuery = fetchBaseQuery({
    baseUrl,
    prepareHeaders: (headers, { getState }) => {
      const token = getState().auth.token;
      if (token) {
        headers.set("jwtToken", token);
      }
      return headers;
    },
  });
  return rawBaseQuery(args, api, extraOptions);
};

export const veevaApi = createApi({
  reducerPath: "veevaApi",
  baseQuery: dynamicBaseQuery,
  tagTypes: ["ReconAudit", "Dashboard", "Approvals", "ActionAudit"],
  endpoints: (builder) => ({
    getDashboardMetrics: builder.query({
      query: () => ({ url: "/api/dashboard" }),
      providesTags: ["Dashboard"],
    }),
    getReconAudit: builder.query({
      query: (params) => ({ url: "/api/recon/audit", params }),
      providesTags: ["ReconAudit"],
    }),
    searchRecon: builder.query({
      query: (params) => ({ url: "/api/recon/search", params }),
    }),
    getPendingApprovals: builder.query({
      query: () => ({ url: "/api/approvals/pending" }),
      providesTags: ["Approvals"],
    }),
    getReconActionAudit: builder.query({
      query: () => ({ url: "/api/recon-action-audit" }),
      providesTags: ["ActionAudit"],
    }),
    markIgnorePending: builder.mutation({
      query: ({ reconId, comments }) => ({
        url: `/api/recon/audit/${reconId}/ignore-request`,
        method: "POST",
        body: { comments: comments ?? "" },
      }),
      invalidatesTags: ["ReconAudit", "Approvals"],
    }),
    processApproval: builder.mutation({
      query: ({ reconId, action }) => ({
        url: `/api/approvals/${reconId}/action`,
        method: "POST",
        body: { action },
      }),
      invalidatesTags: ["Approvals", "ReconAudit", "ActionAudit"],
    }),
  }),
});

export const {
  useGetDashboardMetricsQuery,
  useGetReconAuditQuery,
  useLazyGetReconAuditQuery,
  useSearchReconQuery,
  useGetPendingApprovalsQuery,
  useGetReconActionAuditQuery,
  useMarkIgnorePendingMutation,
  useProcessApprovalMutation,
} = veevaApi;
